module.exports = __webpack_public_path__ + "sunsemweb/img/11.00976d3e.png";